const Hider = ({ children, hidden }) => {
  if (hidden) return null;
  return children;
};

export default Hider;
